export default __webpack_public_path__ + "media/images/front/about/select_plan-55709864599cae7c6c198595eb68d47a.png";